import { render, staticRenderFns } from "./AuthPopupLayout.vue?vue&type=template&id=3cc2d822&"
import script from "./AuthPopupLayout.vue?vue&type=script&lang=js&"
export * from "./AuthPopupLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports